import moment from "moment"

export const transformSearchedRascunho = (item) => {
  let verifyNameFor = ['N', 'C', 'CR', 'O', 'NT', 'D']
  let document = item.document

  // Data Criação é created_at
  document.dataCriacao =  moment(item.created_at).format('YYYY-MM-DD')

  let tipo = document.tipo_registro || document.registro.tipo_registro

  let { rascunho_id } = item

  if (verifyNameFor.includes(tipo)) {
    const { pessoa, pessoas } = document

    if (tipo !== 'O' && tipo !== 'NT') {
      document.nome = (pessoa && pessoa.nome) || (pessoas && pessoas[0].nome) || ''
    }

    document.tipo_registro = tipo
    document.rascunho_id = rascunho_id
  }

  return document
}
